import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    getProductByName,
    GetProductsByQueryParams,
    getProductReferences,
    getProductsByIds,
    getProductsByQuery,
} from '../clients/product.api';

export interface ProductComboBoxOptionsParams {
    defaultProductIds?: string[];
    excludedProductIds?: string[];
    searchQuery: string;
    suggestedProductName?: string;
    vesselId?: string;
}

interface SelectedProductComboBoxOptionParams {
    defaultProductIds?: string[];
    productId: string;
}

interface EquivalentProductComboBoxOptionsParams {
    excludedProductId: string;
    searchQuery: string;
    supplierProductGroup: string;
}

export const products = createQueryKeys('products', {
    pagination: (params: GetProductsByQueryParams) => ({
        queryKey: [params],
        queryFn: () => getProductsByQuery(params),
    }),
    byId: (productIds: string[]) => ({
        queryKey: [{ productIds }],
        queryFn: () => getProductsByIds(productIds),
    }),
    byName: (params: { productName: string; fuzzy?: boolean }) => ({
        queryKey: [params],
        queryFn: () => getProductByName(params),
    }),
    comboBoxOptions: (params: ProductComboBoxOptionsParams) => ({ queryKey: [{ params }] }),
    selectedComboBoxOption: (params: SelectedProductComboBoxOptionParams) => ({ queryKey: [{ params }] }),
    equivalentComboBoxOptions: (params: EquivalentProductComboBoxOptionsParams) => ({ queryKey: [{ params }] }),
    references: (productId: string) => ({
        queryKey: [{ productId }],
        queryFn: () => getProductReferences(productId),
    }),
});
